import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { AttributeQueryKeys } from './attributeQueryKeys';

export type DeleteAttributeAliasVariables = {
    typeId: string;
    valueId: string;
    aliasId: string;
};

export const useDeleteAttributeAliasMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<ApiResponse<void>, Error, DeleteAttributeAliasVariables>(
        {
            mutationFn: ({ typeId, valueId, aliasId }) =>
                apiClient.attributeTypes.deleteAlias(typeId, valueId, aliasId),
            onSuccess: (result) => {
                if (result.success) {
                    queryClient.invalidateQueries({
                        queryKey: AttributeQueryKeys.all,
                    });
                }
            },
        },
    );
};
